var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeDesktopShortShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  viewBox: "0 0 20 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m10.99.216 8.75 8.18a.83.83 0 0 1 0 1.208l-8.75 8.18c-.513.48-1.34.108-1.34-.604V13.6c-4.91 0-7.497 1.895-8.72 3.252-.284.315-.951.113-.93-.314.18-3.585 1.49-11.72 9.65-11.72V.82c0-.712.827-1.084 1.34-.604"
})));
export default SvgYoutubeDesktopShortShare;